export default __webpack_public_path__ + "static/media/driver-icon.57c84ce1.svg";